import React from "react";
import { cn } from "@/utils/cn";
const SparkTemplatesList = ({ data, selectedItem, updateSelectedItem }) => {
    return (React.createElement("div", { className: "grid grid-cols-3 gap-4" }, data.map((item) => (React.createElement("div", { key: item.id, className: cn("bg-[#F8FAFC] rounded-md shadow-sm p-4 cursor-pointer  border-1", selectedItem?.id === item.id && "border-[#8556EB] "), onClick: () => updateSelectedItem(item.id) },
        React.createElement("div", { className: "gap-4 flex" },
            React.createElement("div", null,
                React.createElement("img", { src: item?.wizard?.base64StringLogo, alt: item.title, className: "w-12 h-12 object-cover rounded-md" })),
            React.createElement("div", null,
                React.createElement("div", { className: "text-base font-bold" }, item.name))),
        React.createElement("div", { className: "mt-2" },
            React.createElement("div", { className: "text-sm text-[#868595]" }, item.description || item.wizard.description)))))));
};
export default SparkTemplatesList;
